<template>
  <div class="poster">
    <div class="cover">
      <img src="@/assets/emp-banner.png" alt class="top-cover" />
    </div>
    <div class="warp">
      <!-- <van-tab title="公益需求" name="0" class="wrap-tab">
          <van-cell-group class="wrap-cell-group">
            <van-field clickable required label="企业名称" placeholder="请填写企业名称" v-model="compname" />
            <van-field clickable required label="所在城市" placeholder="请输入所在城市" v-model="city" />
            <van-field
              readonly
              clickable
              label="所在区域"
              v-model="itemext1"
              placeholder="请选择"
              required
              @click="selectWitch()"
              right-icon="arrow"
            />
            <van-field clickable required label="行业" placeholder="请填写行业" v-model="industry" />
            <van-field clickable required label="工种" placeholder="请填写工种" v-model="jobtype" />
            <van-field
              clickable
              required
              v-model="begintime"
              clearable
              label="开始时间"
              placeholder="请选择开始时间"
              @focus="start"
              right-icon="arrow"
            />
            <van-field clickable required label="工作时长" placeholder="请填写工作时长" v-model="worktime" />
            <van-field clickable required label="需求人数" placeholder="请填写需求人数" v-model="needcount" />
            <van-field clickable required label="联系电话" placeholder="请填写电话号码" v-model="phonenum" />
            <van-field clickable required label="联系人" placeholder="请填写联系人姓名" v-model="contacter" />

            <van-field clickable required label="详细地址" placeholder="请填写详细地址" v-model="address" />
            <van-field clickable  label="推荐码" placeholder="请填写推荐码" v-model="recommendcode" />
            <van-field
              readonly
              clickable
              label="是否需要全程落地支持"
              :value="islanding"
              placeholder="请选择"
              required
              @click="selectWitchss('islanding')"
              right-icon="arrow"
            />
            <van-field
              clickable
              type="textarea"
              required
              label="工作内容"
              placeholder="请填写详细的工作内容"
              v-model="workdetail"
            />
          </van-cell-group>
          <van-popup v-model="showPickers" position="bottom">
            <van-picker
              show-toolbar
              :columns="showColumnss"
              @cancel="showPickers = false"
              @confirm="onConfirms"
            />
          </van-popup>
          开始时间控件
          <van-popup v-model="show" position="bottom">
            <van-datetime-picker
              v-model="currentDate"
              type="date"
              @confirm="confirm"
              @cancel="cancel"
              :formatter="formatter"
            />
          </van-popup>
          地区选择
          <van-popup v-model="showdiqu" position="bottom">
            <van-area
              :area-list="areaList"
              v-model="itemext1"
              @confirm="areaConfirm"
              @cancel="areaCancel"
            />
          </van-popup>
          <van-row class="buttonWarp">
            <van-button size="large" type="info" class="button" plain @click="employ">提交</van-button>
            <div class="huoquTitle">
              <p>一键获取“共享员工”落地解决方案：</p>
              <span @click="phoneClick">123456789101</span>
            </div>
          </van-row>
      </van-tab>-->
      <van-form @submit="employs" validate-first>
        <van-cell-group class="wrap-cell-wrap">
          <van-field
            clickable
            required
            label="企业名称"
            placeholder="请填写企业名称"
            v-model="compnames"
            :rules="[{ required: true, message: '请填写企业名称' }]"
          />
          <van-field
            readonly
            clickable
            label="所在区域"
            v-model="itemext1s"
            placeholder="请选择"
            required
            @click="selectWitchs()"
            right-icon="arrow"
            :rules="[{ required: true, message: '请选择' }]"
          />
          <van-field
            clickable
            required
            label="行业"
            placeholder="请填写行业"
            v-model="industrys"
            :rules="[{ required: true, message: '请填写行业' }]"
          />
          <van-field
            clickable
            required
            label="工种"
            placeholder="请填写工种"
            v-model="jobtypes"
            :rules="[{ required: true, message: '请填写工种' }]"
          />
          <van-field
            type="tel"
            clickable
            required
            label="工作时长"
            placeholder="请填写需求时长"
            v-model="worktimes"
            :rules="[{ required: true, message: '请填写需求时长' }]"
          >
            <span slot="button" class="time-month">/月</span>
          </van-field>
          <van-field
            type="tel"
            clickable
            required
            label="需求人数"
            placeholder="请填写需求人数"
            v-model="needcounts"
            :rules="[{ required: true, message: '请填写需求人数' }]"
          />
          <!-- <van-field clickable required v-model="begintimes" clearable label="开始时间" placeholder="请选择开始时间" @focus="starts"  right-icon="arrow"/> -->
          <!-- <van-field clickable required label="所在城市" placeholder="请输入所在城市" v-model="city" /> -->
          <!-- <van-field clickable required label="开工时间" placeholder="请输入开工时间" v-model="post" /> -->
          <van-field
            type="tel"
            clickable
            required
            label="联系电话"
            placeholder="请填写电话号码"
            v-model="phonenums"
            :rules="[{ required: true, message: '请填写电话号码' }]"
          />
          <van-field
            clickable
            required
            label="联系人"
            placeholder="请填写联系人姓名"
            v-model="contacters"
            :rules="[{ required: true, message: '请填写联系人姓名' }]"
          />

          <!-- <van-field clickable required label="详细地址" placeholder="请填写详细地址" v-model="addresss" /> -->
          <!-- <van-field clickable  label="推荐码" placeholder="请填写推荐码" v-model="recommendcodes" /> -->

          <!-- <van-field  v-if="phone =='否'" clickable type="textarea" required label="工作内容" placeholder="请输入" v-model="phone" /> -->
          <!-- <van-field v-if="phone=='是'" clickable label="单位名称" placeholder="请填写企业单位名称" v-model="ishrrecommend"/> -->
          <van-field
            readonly
            clickable
            label="是否需要全程落地支持"
            :value="islandinga"
            placeholder="请选择"
            required
            @click="selectWitchssa('islandinga')"
            right-icon="arrow"
            :rules="[
                  { required: true, message: '请选择' }
                ]"
          />
          <van-field
            clickable
            type="textarea"
            required
            label="工作内容"
            placeholder="请填写详细工作内容"
            v-model="workdetails"
            :rules="[{ required: true, message: '请填写详细工作内容' }]"
          />
        </van-cell-group>
        <!-- 是否 -->
        <van-popup v-model="showPickersa" position="bottom">
          <van-picker
            show-toolbar
            :columns="showColumnssa"
            @cancel="showPickersa = false"
            @confirm="onConfirmsa"
          />
        </van-popup>
        <!-- 开始时间控件 -->
        <van-popup v-model="shows" position="bottom">
          <van-datetime-picker
            v-model="currentDates"
            type="date"
            @confirm="confirms"
            @cancel="cancels"
            :formatter="formatter"
          />
        </van-popup>
        <!-- 地区选择 -->
        <van-popup v-model="showdiqus" position="bottom">
          <van-area
            :area-list="areaList"
            v-model="itemext1s"
            @confirm="onAddConfirms"
            @cancel="onAddCancels"
          />
        </van-popup>
        <div v-show="errorMess" class="errorMessage">{{ txt }}</div>
        <van-row class="buttonWarp">
          <!-- <van-button size="large" type="info" class="button" plain @click="employs">提交</van-button> -->
          <van-button size="large" type="primary" class="button" plain native-type="submit">提交</van-button>
          <!-- <div class="huoquTitles">
              <p>一键获取“共享员工”落地解决方案：</p>
              <span @click="phoneClicks">010-85692930</span>
          </div>-->
        </van-row>
      </van-form>
    </div>
  </div>
</template>

<script>
import { getAreass, submits, submitTwo } from "../api/test";
// import axios from 'axios'
export default {
  data() {
    return {
      errorMess: false,
      currentDate: new Date(), //开始标准时间
      show: false, //开始时间弹窗
      showdiqu: false,

      shows: false, //开始时间弹窗
      currentDates: new Date(), //开始标准时间
      showdiqus: false,
      areaList: {},

      showPickers: false,
      showColumnss: ["是", "否"],
      phone: "",

      showPickersa: false,
      showColumnssa: ["是", "否"],
      phones: "",

      isShowSubscripButton: true,
      showColumns: [],
      showPicker: false,
      nowSelect: "",
      active: 0,
      count: 0,
      city: "",
      shareShow: false,
      thirdChannelLogo: "",
      showReport: false,
      columns: {
        itemext1: ["北京", "上海"],
        begintime: ["2019", "2020"]
      },

      compname: "",
      type: "",
      address: "",
      begintime: "",
      worktime: "",
      phonenum: "",
      contacter: "",
      recommendcode: "",
      needcount: "",
      itemext1: "",
      workdetail: "",
      jobtype: "",
      industry: "",
      islanding: "",
      islandingo: "",

      compnames: "",
      types: "",
      addresss: "",
      begintimes: "",
      worktimes: "",
      phonenums: "",
      contacters: "",
      recommendcodes: "",
      needcounts: "",
      itemext1s: "",
      workdetails: "",
      jobtypes: "",
      industrys: "",
      islandinga: "",
      islandingao: "",
      cityCode: "",
      cityCodes: "",
      txt: ""
    };
  },
  mounted() {
    this.getAreas();
    //this.getArea('',0)           //渲染页面时请求第一层省级数据
  },
  created() {},

  methods: {
    phoneClick() {
      console.log("tag", "45466546");
    },
    phoneClicks() {
      console.log("tag", "45466546");
    },
    selectWitchss() {
      this.showPickers = true;
    },
    onConfirms(value) {
      console.log(value);
      this.islanding = value;
      this.showPickers = false;
      if (value == "是") {
        this.islandingo = 1;
      } else if (value == "否") {
        this.islandingo = 0;
      }
    },
    selectWitchssa() {
      this.showPickersa = true;
    },
    onConfirmsa(value) {
      this.islandinga = value;
      this.showPickersa = false;
      if (value == "是") {
        this.islandingao = 1;
      } else if (value == "否") {
        this.islandingao = 0;
      }
    },
    // 选择开始时间
    start() {
      this.show = true;
    },
    // 点击确定
    confirm() {
      this.show = false;
      this.begintime =
        this.currentDate.getFullYear() +
        "/" +
        ((Number(this.currentDate.getMonth()) + 1 >= 1) &
        (Number(this.currentDate.getMonth()) + 1 <= 9)
          ? "0" + (Number(this.currentDate.getMonth()) + 1)
          : Number(this.currentDate.getMonth()) + 1) +
        "/" +
        this.currentDate.getDate();
      // this.begintime =
      //   this.currentDate.getFullYear() +
      //   "/" +
      //   (Number(this.currentDate.getMonth()) + 1) +
      //   "/" +
      //   this.currentDate.getDate() +
      //   "/"
    },
    // 点击取消
    cancel() {
      this.show = false;
    },
    // 处理控件显示的时间格式
    formatter(type, value) {
      // 格式化选择器日期
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      } else if (type === "day") {
        return `${value}日`;
      }
      return value;
    },

    selectWitch() {
      this.showdiqu = true;
    },
    areaConfirm(val) {
      this.showdiqu = false;
      this.itemext1 = val[0].name + "" + val[1].name + val[2].name;
      this.cityCode = val[0].code;
    },
    areaCancel() {
      this.showdiqu = false;
    },

    // 选择开始时间
    starts() {
      this.shows = true;
    },
    // 点击确定
    confirms() {
      this.shows = false;
      this.begintimes =
        this.currentDates.getFullYear() +
        "/" +
        (Number(this.currentDates.getMonth()) + 1 >= 1 &&
        Number(this.currentDates.getMonth()) + 1 <= 9
          ? "0" + (Number(this.currentDates.getMonth()) + 1)
          : Number(this.currentDates.getMonth()) + 1) +
        "/" +
        this.currentDates.getDate();
    },
    // 点击取消
    cancels() {
      this.shows = false;
    },
    selectWitchs() {
      this.showdiqus = true;
    },
    onAddConfirms(val) {
      this.showdiqus = false;
      this.itemext1s = val[0].name + "" + val[1].name + val[2].name;
      this.cityCodes = val[0].code;
    },
    onAddCancels() {
      this.showdiqus = false;
    },

    // 城市接口
    getAreas() {
      var params = {};
      getAreass("/getArea", params).then(res => {
        // this.areaList = res.data;
        //console.log(267,res.data)
        this.areaList = eval("(" + res.data + ")");
      });
    },

    // 公益需求
    employ() {
      var params = {
        compname: this.compname,
        type: 0,
        industry: this.industry,
        jobtype: this.jobtype,
        // address:this.address,
        begintime: "",
        worktime: this.worktime,
        phonenum: this.phonenum,
        contacter: this.contacter,
        // recommendcode:this.recommendcode,
        needcount: this.needcount,
        itemext1: this.itemext1,
        workdetail: this.workdetail,
        islanding: this.islandingo,
        itemcode: this.cityCode
      };
      submits("/iWant", params, {
        // headers: {
        //    'content-type': 'application/form;charset=utf-8',
        // }
      })
        .then(
          function(res) {
            if (res.msg == "请求成功") {
              this.$router.push({ path: "/UploadResult" });
              let storages = window.localStorage;
              let compId = res.data;
              storages.setItem("compId", JSON.stringify(compId));
            }
          }.bind(this)
        )
        .catch(function(error) {
          console.log(error);
        });
    },
    // 企业需求
    employs() {
      var params = {
        compname: this.compnames,
        type: 1,
        industry: this.industrys,
        jobtype: this.jobtypes,
        // address:this.addresss,
        begintime: "",
        worktime: this.worktimes,
        phonenum: this.phonenums,
        contacter: this.contacters,
        recommendcode: "",
        needcount: this.needcounts,
        itemcode: this.cityCodes,
        itemext1: this.itemext1s,
        workdetail: this.workdetails,
        islanding: this.islandingao
      };
      submitTwo("/iWant", params, {
        // headers: {
        //    'content-type': 'application/form;charset=utf-8',
        // }
      })
        .then(
          function(res) {
            if (res.msg == "请求成功") {
              this.$router.push({ path: "/UploadResult" });
              let storages = window.localStorage;
              let compId = res.data;
              storages.setItem("compId", JSON.stringify(compId));
            } else {
              this.errorMess = true;
              this.txt = res.msg;
            }
          }.bind(this)
        )
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped lang="less">
div {
  box-sizing: border-box;
}
.warp {
  height: 70%;
  background: #fa743d;
  margin: 0 15px;
  border-radius: 9px;
  padding-bottom: 30px;
  .wrap-cell-wrap {
    padding: 0 7px;
  }
}
/deep/.wrapBox::after {
  border-top: none;
}
.buttonWarp {
  padding-top: 20px;
  text-align: center;
  // margin-bottom: 116px;
  background: #fff;
  border-bottom-left-radius: 9px;
  border-bottom-right-radius: 9px;
}
.button {
  width: 90%;
  border-radius: 5px;
  background-color: #4ac7a9;
  color: #fff;
  margin-bottom: 20px;
}
.poster {
  background: #fa743d;
  position: relative;
  width: 100%;
  .cover {
    width: 100%;
    position: relative;
    .top-cover {
      width: 100%;
      max-height: 100%;
      vertical-align: bottom;
      overflow: hidden;
    }
  }
}

.shoukuan {
  padding-top: 44px;
  .van-button--large {
    width: 92%;
    margin-left: 4%;
    margin-top: 25%;
  }
}
svan-tabs {
  border-radius: 10px;
}
.huoquTitle {
  width: 90%;
  height: 40px;
  margin-left: 6%;
  display: flex;
}
.huoquTitle p {
  font-size: 13px;
  color: #666;
}
.huoquTitle span {
  font-size: 13px;
  color: #3385ff;
}
.huoquTitles {
  width: 90%;
  height: 40px;
  margin-left: 6%;
  display: flex;
}
.huoquTitles p {
  font-size: 13px;
  color: #666;
}
.huoquTitles span {
  font-size: 13px;
  color: #3385ff;
}

/deep/.van-hairline--top-bottom {
  border-radius: 9px 9px 0 0;
}
/deep/.van-hairline--top-bottom::after {
  border-top: none;
}
.errorMessage {
  width: 100%;
  height: 30px;
  color: red;
  font-size: 14px;
  text-align: center;
  margin-bottom: -30px;
}
.time-month {
  font-size: 14px;
  font-family: PingFang SC;
  color: #323233;
}
</style>
